import { useNavigationHelper, useTargetBrandConfig } from 'FrontRoyalAngular';
import { useTranslation } from 'react-i18next';
import { useMemo, memo } from 'react';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { BasicDesktopBox } from '../../BasicDesktopBox';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';

function FollowUsBoxComponent() {
    const brandConfig = useTargetBrandConfig();
    const { loadUrl } = useNavigationHelper();
    const { t } = useTranslation('back_royal', { keyPrefix: 'followUsBox' });
    const buttons = useMemo(
        () => [
            {
                id: 'button_follow_us',
                text: t('button_follow_us'),
                onPress: () => loadUrl(brandConfig.followUsUrl, '_blank'),
            },
        ],
        [t, loadUrl, brandConfig],
    );
    return <FollowUsBoxPresentation buttons={buttons} institutionName={brandConfig.brandNameShort} />;
}

function FollowUsBoxPresentation({ buttons, institutionName }: { buttons: ButtonConfig[]; institutionName: string }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'followUsBox' });
    return (
        <BasicDesktopBox
            headerText={t('heading', { institutionName })}
            buttons={buttons}
            boxKey={SidebarBoxKey.follow_us}
        >
            {t('content')}
        </BasicDesktopBox>
    );
}

export const FollowUsBox = memo(FollowUsBoxComponent);
